import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { learnService } from '../../services/learnService';
import { VideoLesson } from './VideoLesson';

/** The training videos, newest first. Links are short-lived, so this is
 *  fetched on each visit rather than cached for long. */
export function LearnVideos() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['learn-videos'],
    queryFn: learnService.getLearnVideos,
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
        <Loader2 className="w-4 h-4 animate-spin" /> Loading videos…
      </div>
    );
  }
  if (error) {
    return (
      <p className="text-sm text-danger-600 dark:text-danger-400">
        The videos could not be loaded. Pull to refresh or try again in a
        moment.
      </p>
    );
  }
  if (!data || data.length === 0) {
    return (
      <p className="text-sm text-slate-500 dark:text-slate-400">
        No videos yet.
      </p>
    );
  }
  return (
    <div className="space-y-4" data-testid="learn-videos">
      {data.map((v) => (
        <VideoLesson key={v.id} video={v} />
      ))}
    </div>
  );
}
